import { useAnalytics } from "@codat/analytics";
import { Button, CircleEmptyQuestionIcon } from "@codat/orchard-ui";
import { useUserState } from "portal-ui-remote/UserStateContext";
import * as React from "react";
import { FC } from "react";
import formatUrl from "utils/formatUrl";

import NavDropdown from "components/NavDropdown";

import styles from "./SupportDropdown.module.css";

interface SupportDropdownProps {
  pauseFocusTrap: boolean;
  onContactSalesClick: () => void;
  className?: string;
}

interface SupportRequestFormOptions {
  email?: string;
  subject?: string;
  description?: string;
  companyId?: string;
}

const HELP_CENTER_URL = "https://codat.zendesk.com/hc/en-gb";
const BLOG_URL = "https://www.codat.io/blog";
const NEW_FEATURE_URL =
  "https://portal.productboard.com/codat/7-product-roadmap/tabs/20-accounting-api/submit-idea";
const CONTACT_SUPPORT_URL = "https://codat.zendesk.com/hc/en-gb/requests/new";

function getSupportFormLink({
  email = "",
  subject = "",
  description = "",
  companyId = "",
}: SupportRequestFormOptions) {
  return `${CONTACT_SUPPORT_URL}${formatUrl(
    "",
    {},
    {
      tf_anonymous_requester_email: email,
      tf_subject: subject,
      tf_description: description,
      tf_360008497178: companyId,
    }
  )}`;
}

const SupportDropdown: FC<SupportDropdownProps> = ({
  pauseFocusTrap,
  onContactSalesClick,
  className,
}) => {
  const { sendEvent } = useAnalytics();
  const { userState } = useUserState();

  const description = `
    Client name: ${userState?.clientName ?? "Not provided"}
    <br>
Client ID: ${userState?.id ?? "Not provided"}
    <br>
User: ${userState?.userName ?? "Not provided"}
<br><br>
Issue: Describe your issue in as much detail as possible
`;
  const contactSupportUrlWithParameters = getSupportFormLink({
    subject: userState?.clientName
      ? `Support request: ${userState?.clientName}`
      : "Support request",
    email: userState?.email,
    description,
  });

  return (
    <NavDropdown
      data-testid="support-dropdown"
      className={className}
      trigger={
        <Button
          data-testid="feedback-button"
          variant="tertiary"
          onClick={() => sendEvent("Support Dropdown - Click")}
          color="interface"
          aria-label="Support"
          size="small"
        >
          <CircleEmptyQuestionIcon className={styles.supportIcon} />
        </Button>
      }
      label="Support"
      activeButton={undefined}
      pauseFocusTrap={pauseFocusTrap}
      menuItems={[
        {
          buttonText: "Help center",
          path: undefined,
          href: HELP_CENTER_URL,
          permission: true,
        },
        {
          buttonText: "Blog",
          path: undefined,
          href: BLOG_URL,
          permission: true,
        },
        {
          buttonText: "Request a new feature",
          path: undefined,
          href: NEW_FEATURE_URL,
          permission: true,
        },
        {
          buttonText: "Contact support",
          path: undefined,
          href: contactSupportUrlWithParameters,
          permission: true,
        },
        {
          buttonText: "Contact sales",
          path: undefined,
          onClick: onContactSalesClick,
          permission: true,
        },
      ]}
      eventProperties={{}}
      header={{ title: "Support", icon: <CircleEmptyQuestionIcon /> }}
    />
  );
};

export default SupportDropdown;
